import React from "react";
import { Link } from "react-router-dom";

export default function ResearchAndDevlopRedesign() {
  const cards = [
    {
      title: "Generics Formulation",
      icon: (
        // Pill Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.5 12a7.5 7.5 0 0015 0 7.5 7.5 0 00-15 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.5v15" />
        </svg>
      ),
      highlight: "We know value of time in Generic Product Development.",
      desc: "At DelNova we have a team of experienced product development scientists, who work hand in hand with analytical and other cross-functional teams to work on expedited timelines for Generic product development. We help our partners to meet timelines with cost-effective formulations and robust manufacturing processes.",
      link: "/GenericsProduct",
      isExternal: false,
    },
    {
      title: "Complex Generics Formulation",
      icon: (
        // Molecule / Chemistry structure Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      highlight: "We understand complexity of Product and Process.",
      desc: (
        <>
          Our openness in thinking and listening helps us develop innovative approaches for Complex Formulations. We convert complex formulations to Bioequivalent Generics with our <strong className="font-semibold text-slate-800">Quality <span className="text-[#e27337] italic font-normal">iN</span> Design</strong> approach. We believe in <strong className="font-semibold text-slate-800">'Do It Right the First Time'</strong>, and our supply chain team helps us get Quality raw materials, promptly for timely prototype delivery. This helps our partners stay ahead in competitive First-to-File and First-to-Market opportunities.
        </>
      ),
      link: "/ComplexGenerics",
      isExternal: false,
    },
    {
      title: "Differentiated Formulation",
      icon: (
        // Laboratory Beaker / Flask Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      highlight: "Unique processes yielding specialized formulations.",
      desc: (
        <>
          Our highly qualified formulation and analytical team has deep expertise in developing formulations, analytical methods catering with unique, solvent-free processes. Using our <strong className="font-semibold italic text-slate-800">Design of Experiments (DoE)</strong> studies and advanced technology platforms, we create proprietary intellectual properties (IPs). We explore each drug substance we touch with the goal of creating safer, more effective, and economical products.
        </>
      ),
      link: "/DifferntiatedProdDev",
      isExternal: false,
    },
    {
      title: "Innovative Formulation",
      icon: (
        // Lightbulb / Idea Icon
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      highlight: "We believe - An Idea can change life.",
      desc: (
        <>
          Our collaboration with global academic institutes and budding scientists helps us harness the best innovative thoughts. We support New Chemical Entity (NCE) companies to develop <strong className="font-semibold text-slate-800">First-in-Human formulations</strong>, while encouraging our internal scientists to generate IPs. We give a platform to scientists and startups to bring innovative product miracles directly to patients.
        </>
      ),
      link: "/innovativeprodDev",
      isExternal: false,
    },
  ];

  return (
    <div className="bg-[#F7F9FA] min-h-screen text-slate-800">
      {/* 1. R&D Hero Section */}
      <section className="relative min-h-[40vh] flex items-center justify-center pt-32 pb-16 overflow-hidden bg-brand-blue-deep">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 mix-blend-overlay"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1532187643603-ba119ca4109e?q=80&w=1920&auto=format&fit=crop')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-brand-blue-deep via-brand-blue/90 to-brand-blue/30" />
        <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center text-white z-10">
          <div className="inline-flex items-center space-x-2 bg-brand-teal/20 border border-brand-teal/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-brand-teal-light font-semibold text-xs uppercase tracking-wider">
              Research & Development
            </span>
          </div>
          <h1 className="font-bold tracking-tight mb-4 max-w-5xl mx-auto flex flex-col items-center">
            <span className="text-2xl sm:text-4xl md:text-5xl text-white block mb-2 leading-tight">
              Development Partner for
            </span>
            <span className="text-base sm:text-xl md:text-2xl lg:text-[25px] font-medium block sm:whitespace-nowrap text-white">
              <span>Generics</span>
              <span className="mx-2.5 text-white/40 text-sm font-extralight align-middle select-none">|</span>
              <span>Complex Generics</span>
              <span className="mx-2.5 text-white/40 text-sm font-extralight align-middle select-none">|</span>
              <span>Differentiated Formulations</span>
            </span>
          </h1>
          <p className="max-w-2xl mx-auto text-base md:text-lg text-slate-300 font-light leading-relaxed">
            Helping our partners meet critical timelines and project costs, achieving our mission of <span className="font-semibold text-brand-teal-light">“Reducing the Burden of Healthcare”</span>.
          </p>
        </div>
      </section>

      {/* 2. R&D Offerings Grid */}
      <section className="py-20 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="bg-white border border-slate-100 hover:border-brand-teal/30 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-1 flex flex-col justify-between"
            >
              <div>
                {/* Icon wrapper */}
                <div className="w-14 h-14 rounded-2xl bg-brand-teal-soft flex items-center justify-center text-brand-teal mb-6">
                  {card.icon}
                </div>
                {/* Title */}
                <h3 className="text-xl md:text-2xl font-bold text-brand-blue mb-4">
                  {card.title}
                </h3>
                {/* Bold Highlight Text */}
                <p className="text-brand-blue font-semibold text-sm md:text-base mb-3 leading-relaxed">
                  {card.highlight}
                </p>
                {/* Description */}
                <p className="text-slate-600 font-light text-sm md:text-base leading-relaxed">
                  {card.desc}
                </p>
              </div>

              {/* Action Button/Link */}
              <div>
                {card.isExternal ? (
                  <a
                    href={card.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-brand-teal hover:text-brand-teal-dark text-sm font-semibold mt-6 transition-colors group"
                  >
                    <span>Learn More</span>
                    <svg className="w-4 h-4 ml-1.5 transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                ) : (
                  <Link
                    to={card.link}
                    className="inline-flex items-center text-brand-teal hover:text-brand-teal-dark text-sm font-semibold mt-6 transition-colors group"
                  >
                    <span>Learn More</span>
                    <svg className="w-4 h-4 ml-1.5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
